import { render, staticRenderFns } from "./hospitalAccidentListCom.vue?vue&type=template&id=8fb052b6"
import script from "./hospitalAccidentListCom.vue?vue&type=script&lang=js"
export * from "./hospitalAccidentListCom.vue?vue&type=script&lang=js"
import style0 from "./hospitalAccidentListCom.vue?vue&type=style&index=0&id=8fb052b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports